import React, {useMemo} from "react";
import AdminLayout from "@widgets/layout/AdminLayout";
import router, {Route} from "@/routing/Router";
import BusynessEditor from "@widgets/busyness/editor/BusynessEditor";


const BusynessManagement = () => {
    const route: Route = useMemo(() => router.busynessManagement, []);

    return (
        <AdminLayout currentPage={route}>
            <BusynessEditor route={route}/>
        </AdminLayout>
    );
};

export default BusynessManagement;